<input type="file" #file (change)="onFileChange($event)" (click)="clickDrop($event)" [hidden]="true" multiple />
<div>
  <label>Upload de Arquivos</label>
</div>

<div role="button" (click)="!this.listaArquivos || this.listaArquivos.length == 0?file.click(): null" class="alinhamento area d-flex" [ngClass]="dragArea">
  <div class="col justify-content-center texto">
    <div *ngIf="!this.listaArquivos || this.listaArquivos.length == 0; else carregandoArquivosTemplate">
      <div class="row justify-content-center">
        <i class="fas fa-upload fa-3x"></i>
      </div>
      <div class="row justify-content-center">
        <span>Arraste e solte o arquivo aqui ou clique para adicionar</span>
      </div>
    </div>
  </div>
</div>


<ng-template #carregandoArquivosTemplate>
  <div class="container">
    <table class="table table-striped table-bordered mt-3">
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="text-center">#</th>
          <th scope="col">Nome do Arquivo</th>
          <th scope="col" class="text-center">Tamanho</th>
          <th scope="col" class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of listaArquivos; let i = index">
          <td class="text-center">{{ i + 1 }}</td>
          <td class="text-truncate" style="max-width: 250px;">
            {{ item.name }}
          </td>
          <td class="text-center">
            {{ (item.size / 1024 / 1024).toFixed(2) }} MB
          </td>
          <td class="text-center" *ngIf="item['porcentagemEnvio'] && item['porcentagemEnvio'] == -1 ">
            <button (click)="uploadIndividualArquivo($event, i)" class="btn btn-success me-2" title="Enviar">
              <i class="fas fa-upload me-1"></i>
              <span class="ms-2">Enviar</span>
            </button>
            <button (click)="removerListaArquivo($event, i)" class="btn btn-danger" title="Remover">
              <i class="fas fa-times me-1"></i>
              <span class="ms-2">Remover</span>
            </button>
          </td>
          <td class="text-center" style="min-width: 250px;" *ngIf="item['porcentagemEnvio'] && item['porcentagemEnvio'] !=-1 && item['porcentagemEnvio'] < 100">
            <div class="progress d-inline">
              <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                [style.width.%]="item.porcentagemEnvio">
              </div>
              <span class="percent-badge pe-2">{{item.porcentagemEnvio.toFixed(0)}}%</span>
            </div>
          </td>
          <td class="text-center" *ngIf="item['porcentagemEnvio'] >= 100">
            <span>Enviado !</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- <app-upload-progress [listaArquivos]="obterProgresso()"></app-upload-progress> -->

  <div class="row justify-content-end mt-2">
    <button class="btn btn-warning me-2" style="width: fit-content;" (click)="file.click();$event.stopPropagation()">
      <i class="fas fa-plus mt-1"></i>
      Adicionar arquivos
    </button>
    <button class="btn btn-success" style="width: fit-content;" (click)="enviarTodosArquivos($event);">
      <i class="fas fas fa-upload mt-1 me-1"></i>
      Enviar Todos os Arquivos
    </button>
  </div>

</ng-template>
